module.exports = __webpack_public_path__ + "static/media/corporate-services-img19.a6a2659e.jpg";